import HomeButtonImg from "./img/home.png";
import clsx from 'clsx';

import './home-button.css';

const HomeButton = ({ onResetPages, disableBtn, isMenuRetract }) => {
  return (
    <button
      className={clsx('home-button', {
        'home-button--show': !isMenuRetract,
      })}
      onClick={onResetPages}
      disabled={disableBtn}
      aria-label="Voltar ao início"
    >
      <img src={HomeButtonImg} className="home-img" alt="" />
    </button>
  )
}

export default HomeButton;